import React from 'react';
import Modal from '@app/react-common/components/modal/Modal';
import Button from '@app/react-common/components/button/Button';
import { Shippings } from '@app/pages/checkout-app/types';
import { WarningBanner } from '@app/react-common/components/banners/WarningBanner';

interface DiscountWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  deliveryMethodsWithDiscounts: Shippings[];
}

export const DiscountWarningModal: React.FC<DiscountWarningModalProps> = ({
  isOpen,
  onClose,
  onContinue,
  deliveryMethodsWithDiscounts,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="discount-warning-modal">
        <h2 className="discount-warning-modal__title">Discounted Shipping Methods Detected</h2>
        <div className="discount-warning-modal__body">
          <WarningBanner
            title="Some Shipping Methods Won't Be Duplicated"
            content="The following shipping methods include discounts and won't be copied. To include them, please recreate
                these methods manually after duplication."
            hideCloseButton={true}></WarningBanner>
          <ul className="discount-warning-modal__methods-list">
            {deliveryMethodsWithDiscounts.map((method: Shippings) => (
              <li key={method.id} className="discount-warning-modal__method-item">
                {method.name} {method.notes && `| ${method.notes}`}
              </li>
            ))}
          </ul>
        </div>
        <div className="discount-warning-modal__actions">
          <Button onClick={onClose} text="Cancel" size="medium" variant="secondary" />
          <Button onClick={onContinue} text="Continue" size="medium" variant="primary" />
        </div>
      </div>
    </Modal>
  );
};
